import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { MEDIA_TYPE_LABEL } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  index?: number;
}

export default function MediaCard({ item, index = 0 }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 12) * 50}ms` }}
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-200 shadow-sm transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-md">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 91蜜桃影视资源`}
          className="aspect-[2/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-secondary-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {MEDIA_TYPE_LABEL[item.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-secondary-950">
          <i className="ri-star-fill text-[10px]" />
          {item.rating}
        </span>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-secondary-950/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="absolute inset-x-0 bottom-0 translate-y-2 p-2.5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="line-clamp-2 text-[11px] leading-snug text-background-100">
            {item.description}
          </p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-0.5 flex items-center gap-1.5 truncate text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.category}</span>
          <span className="text-foreground-300">·</span>
          <span className="truncate">{item.region}</span>
        </p>
      </div>
    </Link>
  );
}